import React from "react";
import Skeleton from "../../../../../components/ui/Skeleton";
import CommentItem from "./CommentItem";

const CommentThread = ({
  isLoading,
  commentsLength,
  totalComments,
  displayedComments,
  postId,
  isEditing,
  editedText,
  showOptions,
  showReplyInput,
  replyToUser,
  savedSet,
  commentLikePending,
  likedCommentIds,
  COMMENT_MAX_LENGTH,
  optionsMenuRef,
  isCommentOwner,
  setShowOptions,
  setIsEditing,
  setEditedText,
  handleDeleteClick,
  handleCommentEdit,
  handleMentionSelect,
  mentionMap,
  handleCommentLike,
  toggleReplies,
  handleToggleSaveComment,
}) => {
  return (
    <div className="posted-comments">
      {isLoading && commentsLength === 0 && totalComments !== 0 && (
        <div className="space-y-4 px-[15px] mb-4">
          <Skeleton height={100} width="100%" className="rounded-xl" />
          <Skeleton height={100} width="100%" className="rounded-xl" />
        </div>
      )}

      {!isLoading && commentsLength === 0 && (
        <p className="text-center text-sm text-gray-400 py-6 px-4">
          No comments yet. Be the first to comment!
        </p>
      )}

      {displayedComments.map((comment) => (
        <CommentItem
          key={comment.id}
          comment={comment}
          postId={postId}
          isEditing={isEditing}
          editedText={editedText}
          showOptions={showOptions}
          showReplyInput={showReplyInput}
          replyToUser={replyToUser}
          savedSet={savedSet}
          commentLikePending={commentLikePending}
          likedCommentIds={likedCommentIds}
          COMMENT_MAX_LENGTH={COMMENT_MAX_LENGTH}
          optionsMenuRef={optionsMenuRef}
          isCommentOwner={isCommentOwner}
          setShowOptions={setShowOptions}
          setIsEditing={setIsEditing}
          setEditedText={setEditedText}
          handleDeleteClick={handleDeleteClick}
          handleCommentEdit={handleCommentEdit}
          handleMentionSelect={handleMentionSelect}
          mentionMap={mentionMap}
          handleCommentLike={handleCommentLike}
          toggleReplies={toggleReplies}
          handleToggleSaveComment={handleToggleSaveComment}
        />
      ))}
    </div>
  );
};

export default CommentThread;
